<ng-container *ngIf="session as s">
  <div class="es-controls">
    <!-- The count holds its place when there is nothing to count, and it is
         the half of this row that has to. Three grey buttons and no sentence
         is a page that looks broken rather than idle: a disabled button shows
         no tooltip, so the row said nothing at all about why it could not be
         pressed, and the answer - "you have not changed anything yet" - was
         the one thing missing. Reported as "I did not find when they are
         enabled".

         The BUTTONS are the other half, and they do not have to hold their
         place: a control that cannot be pressed is chrome, and on a toolbar
         that wraps it is chrome that costs a whole second row. So they arrive
         with the first change and leave with the last, and the sentence -
         which is what answered that report - stays either way. -->
    <span class="es-count" *ngIf="(s.changes$ | async)?.length as n; else nothingToSave">
      {{ n }} unsaved {{ n === 1 ? 'change' : 'changes' }}
    </span>
    <ng-template #nothingToSave>
      <span class="es-count es-count--none" data-test="no-changes">No unsaved changes</span>
    </ng-template>

    <!-- Still on screen while a save is in flight, because the primary is
         saying "Saving..." and that is the one thing worth reading. -->
    <ng-container *ngIf="(s.changes$ | async)?.length || (s.saving$ | async)">
      <button type="button" class="es-btn br-btn br-btn--outline-secondary br-btn--sm br-icon-btn" (click)="onUndo()"
              [disabled]="disabled || !(s.changes$ | async)?.length || (s.saving$ | async)"
              matTooltip="Undo the last change" aria-label="Undo">
        <br-icon>undo</br-icon>
      </button>

      <button type="button" class="es-btn es-btn--text br-btn br-btn--ghost br-btn--sm" (click)="onCancel()"
              [disabled]="disabled || !(s.changes$ | async)?.length || (s.saving$ | async)"
              matTooltip="Discard every unsaved change">
        Cancel
      </button>

      <button type="button" *ngIf="showSave" class="es-btn es-btn--primary br-btn br-btn--primary br-btn--sm" (click)="onSave()"
              [disabled]="disabled || !(s.changes$ | async)?.length || (s.saving$ | async)">
        {{ (s.saving$ | async) ? 'Saving…' : saveLabel }}
      </button>
    </ng-container>
  </div>

  <!-- Save failed: the edits are still here, so this reads as "retry", not
       "start again". -->
  <div class="es-error" *ngIf="s.saveError$ | async as err" role="alert">
    <br-icon>error_outline</br-icon>
    <span>{{ errorText(err) }}</span>
  </div>

  <div class="es-strip" *ngIf="showChanges && (s.changes$ | async)?.length">
    <div class="es-strip-head">
      <br-icon>edit_note</br-icon>
      <span>This edit session</span>
    </div>
    <ul class="es-strip-list">
      <li *ngFor="let change of s.changes$ | async"
          class="es-change"
          [class.es-change--copilot]="change.origin === 'copilot'">
        <span class="es-change-dot" aria-hidden="true"></span>
        <span class="es-change-label">{{ change.label }}</span>
        <span class="es-change-origin" *ngIf="change.origin === 'copilot'">AI Agent</span>
        <button type="button" class="es-btn es-btn--tiny br-btn br-btn--ghost br-btn--sm br-icon-btn" (click)="onUndoAt(change.index)"
                [matTooltip]="'Undo just this change'"
                [attr.aria-label]="'Undo: ' + change.label">
          <br-icon>undo</br-icon>
        </button>
      </li>
    </ul>
  </div>
</ng-container>
